export default "__VITE_ASSET__BSjkXG_y__"